export default __webpack_public_path__ + "static/media/4.5dfa5b04.jpg";